import Field from './Field';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, props);

        this._input = element.find(`:input[name="${props.name}[]"]`);
    }

    getValue() {
        return this.find(':input')
            .elements()
            .filter(checkbox => checkbox.is(':checked'))
            .map(checkbox => checkbox.val());
    }

    setValue(options) {
        this.find(':input')
            .elements()
            .forEach(checkbox =>
                checkbox.prop('checked', options.includes(checkbox.val())),
            );

        return this;
    }

    setOptions(options = {}, labelField = null, valueField = null) {
        const wrapper = this._wrapper.find('.content-box');
        const name = this.getName();
        const selectedValues = this._wrapper
            .find('input:checked')
            .elements()
            .map(el => el.val());

        wrapper.html('');

        this.normalizeOptions(options, labelField, valueField).forEach(
            ({ value, label }) =>
                wrapper.append(
                    $(`
                        <div>
                            <input type="checkbox" name="${name}[]" value="${value}">                
                            <label class="form-check-label">${label}</label>    
                        </div>
                `),
                ),
        );

        selectedValues.forEach(value =>
            wrapper.find(`input[value='${value}']`).prop('checked', true),
        );
    }
}
